<template>
  <div
    id="footer-layout"
    style=" font-size: 45px; position: fixed; bottom: 0; height: 450px;"
  >
    <b-container
      class="ml-5"
      style="width: 100%"
      fluid
    >
      <b-row>
        <b-col
          style="text-align: left"
          cols="2"
        >
          Report by
        </b-col>
        <b-col cols="3">
          <b-row>
            <b-col>
              {{ latestReport.user.name }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Scientist
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Date  {{ latestReport.created_at }}
            </b-col>
          </b-row>
        </b-col>
        <b-col
          class="text-left"
          cols="2"
        >
          Approve by
        </b-col>
        <b-col cols="3">
          <b-row>
            <b-col>
              {{ latestApprove.user.name }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Medical Laboratory Manager
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Date {{ latestApprove.created_at }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'FooterLayout',
  props: {
    latestReport: {
      type: Object,
      required: true
    },
    latestApprove: {
      type: Object,
      required: true
    }
  }
}
</script>


<style>

</style>

